import React, { useEffect, useMemo, useRef, useState } from "react";
import CustomTable from "../CustomTable";
import CustomButton from "../CustomButton";
import moment from "moment";
import DatePicker from "../FormFields/DatePicker";
import useApi from "../../hooks/useApi";
import apiClient from "../../utils/api/apiClient";
import { apiUrls } from "../../utils/api/apiUrls";
import { l1Columns } from "../Columns/Vouchers/PendingVouchers";
import { storeColumns } from "../Columns/Vouchers/AllVouchers";
import { useAuth } from "../../contexts/AuthContext";
import { toast } from "react-toastify";
import { downloadReports, downloadReportsFun, getArrayOfSelectedStoresCode, switchLabel } from "../../utils/helpers";
import {
  useNavigate,
  createSearchParams,
  useSearchParams,
  useLocation,
} from "react-router-dom";
import RejectModal from "../../CustomRejectModal/RejectModal";
import EditApproveModal from "../../CustomEditApproveModal/EditApproveModal";
import SendBackForReworkModal from "../../CustomSendBackForReworkModal/SendBackForReworkModal";

const PendingApproval = () => {
  const { data = [], apiCall } = useApi();
  const { apiCall: voucherStatusApi } = useApi();
  const {data: fileData,  apiCall: fileDownload } = useApi();
  const {data: fileStoreData,  apiCall: fileDownloadAtStore } = useApi();

  const navigate = useNavigate();
  const loc = useLocation()
  const [searchParams] = useSearchParams();
  const location = useLocation()
  const [startDate, setStartDate] = useState(
    moment(
      searchParams.get("startDate") || moment().subtract({ days: 7 }).toDate()
    ).toDate()
  );
  const [endDate, setEndDate] = useState(
    moment(searchParams.get("endDate") || new Date()).toDate()
  );
  const {
    user: { userLabel = "Store" },
    selectedStores,
    storeDropdownState,
    currentStoreSelect, 
    setCurrentStoreSelect
  } = useAuth();

  const { name: storeName } =
    selectedStores?.storeDetails || selectedStores?.[0] || {name:""};

  const [tableData, setTableData] = useState();
  const [selectedCheckBoxes, setSelectedCheckBoxes] = useState([]);
  const [isRejectVisible, setIsRejectVisible] = useState(false);
  const [isEditApproveVisible, setIsEditApproveVisible] = useState(false);
  const [isSendBackForReworkVisible, setIsSendBackForReworkVisible] = useState({
    isOpen: false,
    data: [],
  });
  const getRecordsInFlightRef = useRef(false);
  const lastFetchKeyRef = useRef("");

  const voucherApiCall = (start, end) => {
    const safeStart = start || new Date();
    const safeEnd = end || safeStart;
    const storeCodes = getArrayOfSelectedStoresCode(selectedStores, storeDropdownState);
    const requestKey = JSON.stringify({
      startDate: moment(safeStart).startOf("d").format("YYYY-MM-DD HH:mm:ss"),
      endDate: moment(safeEnd).endOf("d").format("YYYY-MM-DD HH:mm:ss"),
      metadataSchemaId: 4,
      status: "PENDING",
      storeCodes: Array.isArray(storeCodes) ? [...storeCodes].sort() : [],
    });
    if (
      getRecordsInFlightRef.current &&
      lastFetchKeyRef.current === requestKey
    ) {
      return;
    }
    getRecordsInFlightRef.current = true;
    lastFetchKeyRef.current = requestKey;

    navigate(
      {
        pathname: window.location.pathname,
        search: createSearchParams({
          startDate: safeStart,
          endDate: safeEnd,
        }).toString(),
      },
      { replace: true }
    );
    apiCall({
      url: apiUrls.dmsService.getRecords,
      dataToSend: {
        startDate: moment(safeStart).startOf("d").format("YYYY-MM-DD HH:mm:ss"),
        metadataSchemaId: 4,
        endDate: moment(safeEnd)
          .endOf("d")
          .format("YYYY-MM-DD HH:mm:ss"),
        searchText: "",
        status: "PENDING",
        storeCodes
        // storeCodes: selectedStores?.storeDetails?.storeCode
        //   ? selectedStores?.storeDetails?.storeCode !== "All" ? [selectedStores?.storeDetails?.storeCode] : null
        //   : userLabel == "Store" ? null : [storeCode],
      },
      method: "post",
      onSuccess: () => {
        getRecordsInFlightRef.current = false;
      },
      onFail: () => {
        getRecordsInFlightRef.current = false;
      },
      onError: () => {
        getRecordsInFlightRef.current = false;
      },
      processData: userLabel === "Store",
      accessor: "storeGetResponse",
      itemAccessor: "dataModalRecordsResponse",
    });
  };

  // useEffect(() => {
  //   voucherApiCall(startDate, endDate);
  // }, [selectedStores, userLabel]);

  let pathVar = loc?.pathname?.split("/") || ""
  let subVoucherPath = pathVar[pathVar.length - 1]

  // let currentSubVoucherData = data?.storeWiseRecordsResponses?.find(i => i.storeName == currentStoreSelect)?.documents

  // useEffect(() => {
  //   if(subVoucherPath == "sub-voucher") {
  //     setTableData(currentSubVoucherData || [])
  //   } 
  // }, [data])

  // useEffect(() => {
  //   if(subVoucherPath == "vouchers"){
  //     setTableData(data?.storeWiseRecordsResponses)
  //   } else {
  //     setTableData(currentSubVoucherData)
  //   }
  // }, [subVoucherPath])

  const mapSubVoucherData = () =>{
    let currentSubVoucherData = [];
      if(currentStoreSelect){
        currentSubVoucherData = data?.storeWiseRecordsResponses?.find(
          (i) => i.storeName === currentStoreSelect
        )?.documents;
      }else if(storeName && storeName !== 'All'){
        currentSubVoucherData = data?.storeWiseRecordsResponses?.find(
          (i) => i.storeName === storeName
        )?.documents;
      }else{
        currentSubVoucherData = data?.storeWiseRecordsResponses?.length > 0 ? data?.storeWiseRecordsResponses[0]?.documents : []
      }
      return currentSubVoucherData;
  }

  useEffect(() => {
    if (subVoucherPath === "sub-voucher") {
      setTableData(mapSubVoucherData() || []);
    }
  }, [data]);

  useEffect(() => {
    if (subVoucherPath === "vouchers") {
      setTableData(data?.storeWiseRecordsResponses);
    } else {
      setTableData(mapSubVoucherData());
    }
  }, [subVoucherPath]);

  const storeFetchDependencyKey = useMemo(() => {
    const selectedCode =
      selectedStores?.storeDetails?.storeCode ||
      selectedStores?.storeCode ||
      selectedStores?.value ||
      "";
    const dropdownCount = Array.isArray(storeDropdownState)
      ? storeDropdownState.length
      : storeDropdownState
      ? 1
      : 0;
    return `${selectedCode}|${dropdownCount}`;
  }, [
    selectedStores?.storeDetails?.storeCode,
    selectedStores?.storeCode,
    selectedStores?.value,
    Array.isArray(storeDropdownState) ? storeDropdownState.length : 0,
  ]);

  useEffect(() => {
    voucherApiCall(startDate, endDate);
  }, [storeFetchDependencyKey]);

  const onChangeDate = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if (end) voucherApiCall(start, end);
  };

  const onClickChangeData = (data) => {
    setTableData(data);
  };

  const [decisionStatusMap, setDecisionStatusMap] = useState({}); // Track decision status per sub-voucher

  const voucherStatusApiCall = (payload, status, saveDecisionOnly = false) => {
    voucherStatusApi({
      url: apiUrls.dmsService.approveRequest,
      dataToSend: payload,
      method: "post",
      onSuccess: () => {
        toast.success(status);
        setIsRejectVisible(false);
        setIsEditApproveVisible(false);
        setIsSendBackForReworkVisible({ isOpen: false });
        
        // Update decision status map for saved decisions
        if (saveDecisionOnly) {
          const newDecisionMap = { ...decisionStatusMap };
          if (payload.approved && payload.approved.length > 0) {
            payload.approved.forEach((item) => {
              newDecisionMap[item.id] = "Approved";
            });
          }
          if (payload.rejected && payload.rejected.length > 0) {
            payload.rejected.forEach((id) => {
              newDecisionMap[id] = "Rejected";
            });
          }
          setDecisionStatusMap(newDecisionMap);
        }
        
        setTableData(null);
        voucherApiCall(startDate, endDate);
      },
      onError: (error) => {
        const errorMessage = error?.response?.data?.message || "Operation failed";
        toast.error(errorMessage);
        
        // If error mentions pending sub-vouchers, highlight them
        if (errorMessage.includes("Please complete all sub-voucher actions")) {
          toast.warning("Please complete all sub-voucher decisions before proceeding");
        }
      },
    });
  };

  const isL1 = userLabel === "L1";
  const isL2 = userLabel === "L2";
  const isFinance = userLabel === "Finance";

  const userActiveLevel = userLabel
  const inBetweenColumnsData = (isL2) ? [
    { Header: "Approved by L1", accessor: "l1AmountApproved" },
  ] : [
    { Header: "Approved by L1", accessor: "l1AmountApproved" },
    { Header: "Approved by L2", accessor: "l2AmountApproved" },
  ]

  const approveRequestHandler = (ids = [], comment = "", saveDecisionOnly = true, parentVoucherId = null) => {
    let payload = {
      approved: ids,
      comment,
      rejected: [],
      saveDecisionOnly: saveDecisionOnly, // Save decision but don't advance workflow
    };
    const statusMessage = saveDecisionOnly ? "Decision saved successfully" : "Approved and submitted successfully";

    // When we want "approve + submit all" (saveDecisionOnly false) for a parent voucher, we must:
    // 1) First save the approval decision (saveDecisionOnly true)
    // 2) Then call sendAllToNextLevel(parentId) so the parent voucher moves out of Pending
    // Use apiClient directly so we run step 2 on any 2xx (useApi's onSuccess only runs for a specific response shape).
    if (saveDecisionOnly === false && parentVoucherId != null) {
      const payloadSaveOnly = { ...payload, saveDecisionOnly: true };
      apiClient({
        url: apiUrls.dmsService.approveRequest,
        data: payloadSaveOnly,
        method: "post",
      })
        .then((res) => {
          if (res?.status >= 200 && res?.status < 300) {
            return apiClient({
              url: `${apiUrls.dmsService.sendAllToNextLevel}/${parentVoucherId}`,
              method: "post",
              data: {},
            });
          }
          throw new Error(res?.data?.message || "Approve failed");
        })
        .then((res2) => {
          if (res2?.status >= 200 && res2?.status < 300) {
            toast.success("Approved and submitted successfully");
            setIsRejectVisible(false);
            setIsEditApproveVisible(false);
            setIsSendBackForReworkVisible({ isOpen: false });
            setTableData(null);
            voucherApiCall(startDate, endDate);
          } else {
            throw new Error(res2?.data?.message || "Submit failed");
          }
        })
        .catch((err) => {
          const errorMessage = err?.response?.data?.message || err?.message || "Operation failed";
          toast.error(errorMessage);
          setTableData(null);
          voucherApiCall(startDate, endDate);
        });
      return;
    }

    voucherStatusApiCall(payload, statusMessage, saveDecisionOnly);
  };

  const rejectRequestHandler = (ids, comment, saveDecisionOnly = true) => {
    let payload = {
      approved: [],
      comment,
      rejected: ids,
      saveDecisionOnly: saveDecisionOnly, // Save decision but don't advance workflow
    };
    voucherStatusApiCall(payload, "Decision saved successfully", saveDecisionOnly);
  };

  const sendBackForReworkHandler = (ids = [], comment = "") => {
    let payload = {
      approved: [],
      rejected: [],
      reworkRequested: Array.isArray(ids) ? ids : [ids],
      comment: comment,
    };
    voucherStatusApi({
      url: apiUrls.dmsService.sendBackForRework,
      dataToSend: payload,
      method: "post",
      onSuccess: () => {
        toast.success("Sent Back for Rework Successfully");
        setIsRejectVisible(false);
        setIsEditApproveVisible(false);
        setIsSendBackForReworkVisible({ isOpen: false });
        setTableData(null);
        voucherApiCall(startDate, endDate);
      },
      onError: (error) => {
        toast.error(error?.response?.data?.message || "Failed to send back for rework");
      },
    });
  };

  const nonStoreColumns = useMemo(
    () =>
      l1Columns({
        navigate,
        editApprovalHandler: (ids = [], previousAmounts, totalAmount, storeName) => {
          if (!storeName) {
            setIsEditApproveVisible({
              data: ids,
              isOpen: true,
              previousAmounts,
              totalAmount: totalAmount
            });
          } else {
            approveRequestHandler(ids);
          }
        },
        userActiveLevel: userLabel,
        approveRequestHandler: (ids = [], comment = "", saveDecisionOnly = true, parentVoucherId = null) => {
          approveRequestHandler(ids, comment, saveDecisionOnly, parentVoucherId);
        },
        rejectRequestHandler: (ids = []) => {
          setIsRejectVisible({ data: ids, isOpen: true });
        },
        decisionStatusMap, // Pass decision status map to columns
        extraColumns: (subVoucherPath == "sub-voucher")
          ? [
              {
                Header: "V.ID",
                accessor: "id",
                Cell: (props) => {
                  const id = props?.row?.original?.id;
                  return (
                    <div
                      className="cursor-pointer underline underline-offset-4"
                      style={{ color: "blue" }}
                      onClick={() =>
                        navigate(`/vouchers/${id}`, {
                          state: { ...props.row?.original, type: "Pending" },
                        })
                      }
                    >
                      {id}
                    </div>
                  );
                },
              },
            ]
          : [
              {
                Header: "Store Name",
                accessor: "storeName",
                Cell: (props) => {
                  const store_name = props?.row?.original?.storeName;
                  return (
                    <div
                      className="cursor-pointer underline underline-offset-4"
                      style={{ color: "blue" }}
                      onClick={() => {
                        navigate(
                          {
                            pathname: "sub-voucher",
                            search: createSearchParams({
                              startDate: startDate,
                              endDate: endDate,
                            }).toString(),
                          }
                        );
                        setCurrentStoreSelect(store_name)
                        onClickChangeData(props?.row?.original?.documents);
                      }}
                    >
                      {store_name}
                    </div>
                  );
                },
              },
            ],
        inBetweenColumns : (isL2 || isFinance) ? inBetweenColumnsData : []
        
      }),
    [tableData, startDate, endDate]
  );

  const memoStoreColumns = useMemo(() => storeColumns({ navigate }), []);

  // const onClickDownload = () => {
  //   let reportSettings = {
  //     fileName: "Pending Approval", // Name of the resulting spreadsheet
  //     extraLength: 3, // A bigger number means that columns will be wider
  //     writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
  //     writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
  //     RTL: false, // Display the columns from right-to-left (the default value is false)
  //   };
  //   if (data?.storeWiseRecordsResponses) {
  //     downloadReports(
  //       [
  //         {
  //           sheet: "All Vouchers",
  //           columns: [
  //             {
  //               label: "Store Name",
  //               value: (row) => selectedStores?.storeDetails?.name || "All",
  //             }, // Top level data
  //             { label: "Submitted On", value: (row) => row.submittedOn }, // Top level data
  //             { label: "Amount", value: (row) => row.amount }, // Top level data
  //             { label: "Pending", value: (row) => row.pendingAmount }, // Top level data
  //           ],
  //           content: selectedCheckBoxes.map((item) => item?.original),
  //         },
  //       ],
  //       reportSettings
  //     );
  //   }

  //   if (data?.length > 0) {
  //     downloadReports(
  //       [
  //         {
  //           sheet: "Pending Vouchers",
  //           columns: [
  //             {
  //               label: "VID",
  //               value: (row) => row.vid,
  //             }, // Top level data
  //             { label: "Submitted On", value: (row) => row.submittedOn }, // Top level data
  //             { label: "Amount", value: (row) => row.amount }, // Top level data
  //             {
  //               label: "L1 Status",
  //               value: (row) => row.L1?.status || "-",
  //             }, // Top level data
  //             {
  //               label: "L2 Status",
  //               value: (row) => row.L2?.status || "-",
  //             }, // Top level data
  //             {
  //               label: "A/C Status",
  //               value: (row) => row.L3?.status || "-",
  //             }, // Top level data
  //             {
  //               label: "Approved Amount",
  //               value: (row) => row?.L3?.approvedAmount || "-",
  //             }, // Top level data
  //           ],
  //           content: selectedCheckBoxes.map((item) => item?.original),
  //         },
  //       ],
  //       reportSettings
  //     );
  //   }
  // };

  const getStoreCodeByName = (storeName) => {
    return storeDropdownState.find(i => i.name == storeName)?.storeCode
  }

  const downloadVoucherAtStoreLevel = () => {
    const st =`${moment(startDate).format('YYYY-MM-DD')} 00:00:00`;
    const et = `${moment(endDate).format('YYYY-MM-DD')} 23:59:59`;
    fileDownloadAtStore({
      url: `${apiUrls.dmsService.downloadVoucherStoreLevel}`,
      dataToSend: {
        storeCodes: selectedCheckBoxes?.map((i) =>
          getStoreCodeByName(i.original.storeName)
        ),
        status: "Pending",
        metadataSchemaId: 4,
        endDate: et,
        startDate: st,
      },
      method: "post",
      responseType: "blob",
      responseData: (res) => {
        const { data = "", status = null } = res || {};
        const contentType = res?.headers?.["content-type"];
        const contentDisposition = res?.headers["content-disposition"];
        const fileNameMatch =
          contentDisposition && contentDisposition.match(/filename="(.+)"/);
        const fileName = fileNameMatch
          ? fileNameMatch[1]
          : "downloaded-file.xlsx";
        if (status === 200) {
          toast.success("Download File Successfully");
          downloadReportsFun(data, "PendingVoucher.xlsx", contentType);
        } else {
          toast.success("Something Went Wrong");
        }
      },
    });
  }

  const onClickDownloadFile = () => {
    // const st =`${moment(startDate).format('YYYY-MM-DD')} 00:00:00`;
    // const et = `${moment(endDate).format('YYYY-MM-DD')} 23:59:59`;
    fileDownload({
      url: `${apiUrls.dmsService.getDownloadVoucherReport}`,
      // dataToSend: userLabel == "Store" ? selectedCheckBoxes?.map(i => Number(i.original.vid)):  selectedCheckBoxes?.map(i => Number(i.original.id)) || [],
      dataToSend: {
        voucherIds: userLabel == "Store" ? selectedCheckBoxes?.map(i => Number(i.original.vid)):  selectedCheckBoxes?.map(i => Number(i.original.id)) || [],
        status: "Pending",
      },
      method: "post",
      responseType: "blob",
      responseData: (res) => {
        const { data = "", status = null } = res || {};
        const contentType = res?.headers?.["content-type"];
        const contentDisposition = res?.headers["content-disposition"];
        const fileNameMatch =
          contentDisposition && contentDisposition.match(/filename="(.+)"/);
        const fileName = fileNameMatch
          ? fileNameMatch[1]
          : "downloaded-file.xlsx";
        if(status === 200) {
          toast.success("Download File Successfully");
          downloadReportsFun(data, "PendingVoucher.xlsx", contentType);
        } else {
          toast.success("Something Went Wrong");
        }
      },
    });
  };

  return (
    <div className="flex flex-col py-2">
      <div className="flex justify-end mt-2 mb-8">
        <div className="flex items-center gap-x-3">
          <div className="font-size-medium">Date Range</div>

          <DatePicker
            startDate={startDate}
            endDate={endDate}
            onChange={onChangeDate}
            maxDate={new Date()}
            dateRange
          />
        </div>
      </div>
      <CustomTable
        data={
          tableData
            ? tableData
            : userLabel === "Store"
            ? data
            : data?.storeWiseRecordsResponses || []
        }
        columns={userLabel === "Store" ? memoStoreColumns : nonStoreColumns}
        showCheckboxes={false}
        onCheckboxSelect={(selectedCheckBoxes) => {
          const data1 = tableData
            ? tableData
            : userLabel === "Store"
            ? data
            : data?.storeWiseRecordsResponses || [];
          if (data1?.length) {
            setSelectedCheckBoxes(selectedCheckBoxes);
          }
        }}
        centerAlignedColumns={[
          "l1_status",
          "l2_status",
          "amount",
          "ac_status",
          "approved_amount",
        ]}
        // isGlobalSearchEnable
        // globalSearchPosition={{
        //   top: "-63px",
        //   left: 0,
        // }}
      />
      {/* {userLabel === "Store" ? (
        <CustomButton
          title="Download"
          wrapperClassName={`self-end !px-10 mt-5 ${
            selectedCheckBoxes?.length > 0 ? "" : "disabled-kv"
          }`}
          onClick={() => {
            if(selectedCheckBoxes?.map((item) => item?.original)[0]?.storeName){   
              downloadVoucherAtStoreLevel()
            } else {
              onClickDownloadFile()
            }
          }}
        />
      ) : (
        <div className={`mt-4 flex items-center justify-end gap-x-5`}>
          <CustomButton
            title="Download"
            wrapperClassName={`border-[1px] !border-[var(--blackColor)] !bg-transparent self-end !text-[var(--blackColor)] !px-8 ${
              selectedCheckBoxes?.length > 0 ? "" : "disabled-kv"
            }`}
            onClick={() => {
              if(selectedCheckBoxes?.map((item) => item?.original)[0]?.storeName){
                downloadVoucherAtStoreLevel()
              } else {
                onClickDownloadFile()
              }
            }}          
            />

          <CustomButton
            title="Reject"
            wrapperClassName={`border-[1px] !border-[var(--blackColor)] !bg-transparent self-end !text-[var(--blackColor)] !px-8 ${
              selectedCheckBoxes?.length > 0 ? "" : "disabled-kv"
            }`}
            onClick={() => {
              const ids = [];
              selectedCheckBoxes?.forEach((row) => {
                if (row.original.documents) {
                  row.original.documents?.forEach((row) => {
                    row.pendingDocs?.forEach((row) => {
                      // row?.subHeadDocumentResponseList?.forEach((row) => {
                        // row?.document?.forEach((row) => {
                          ids.push(row?.id);
                        // });
                      // });
                    });
                  });
                }

                // if (row?.original?.pendingDocs) {
                //   row.original?.pendingDocs?.forEach((row) => {
                //     // row?.subHeadDocumentResponseList?.forEach((row) => {
                //       row?.document?.forEach((row) => {
                //         ids.push(row?.id);
                //       });
                //     // });
                //   });
                // }

                if (row?.original?.pendingDocs) {
                  // ids.push({
                  //   id: row?.original?.id,
                  //   approvedAmount: row?.original?.pendingAmount,
                  //   // editAmount: row?.original?.pendingAmount,
                  // });
                  row.original?.pendingDocs.forEach((rowD) => {
                    // row?.subHeadDocumentResponseList?.forEach((row) => {
                    //   row?.document?.forEach((row) => {
                        ids.push(
                          rowD?.id,
                          // approvedAmount: row?.original?.pendingAmount,
                        );
                    //   });
                    // });
                  });
                }
              });

              // debugger
              setIsRejectVisible({ data: ids, isOpen: true });
            }}
          />
          <CustomButton
            title="Approve"
            wrapperClassName={`border-[1px] !border-[var(--blackColor)] !bg-transparent self-end !text-[var(--blackColor)] !px-8 ${
              selectedCheckBoxes?.length > 0 ? "" : "disabled-kv"
            }`}
            onClick={() => {
              const ids = [];
              selectedCheckBoxes.forEach((row) => {
                if (row.original.documents) {
                  row.original.documents.forEach((row) => {
                    row.pendingDocs.forEach((row) => {
                      // row?.subHeadDocumentResponseList?.forEach((row) => {
                        // row?.document?.forEach((row) => {
                          ids.push({
                            id: row?.id,
                            approvedAmount: row?.dataModalAttributeSet?.find(
                              (item) => item.metadataTechnicalName == switchLabel(userActiveLevel)
                            )?.attributeValue,
                            // editAmount: row?.original?.pendingAmount,
                          });
                        // });
                      // });
                    });
                  });
                }

                if (row?.original?.pendingDocs) {
                  // ids.push({
                  //   id: row?.original?.id,
                  //   approvedAmount: row?.original?.pendingAmount,
                  //   // editAmount: row?.original?.pendingAmount,
                  // });
                  row.original?.pendingDocs.forEach((rowD) => {
                    // row?.subHeadDocumentResponseList?.forEach((row) => {
                    //   row?.document?.forEach((row) => {
                        ids.push({
                          id: rowD?.id,
                          // approvedAmount: row?.original?.pendingAmount,
                          approvedAmount: rowD?.dataModalAttributeSet?.find(
                            (item) => item.metadataTechnicalName == switchLabel(userActiveLevel)
                            )?.attributeValue,
                        });
                    //   });
                    // });
                  });
                }
              });
              approveRequestHandler(ids);
            }}
          />
        </div>
      )} */}
      {isRejectVisible?.isOpen && (
        <RejectModal
          isModalVisible={isRejectVisible}
          setIsModalVisible={setIsRejectVisible}
          rejectHandler={({ data = [], comment = "" }) => {
            rejectRequestHandler(data, comment, true); // saveDecisionOnly = true
          }}
        />
      )}

      {isEditApproveVisible.isOpen && (
        <EditApproveModal
          isModalVisible={isEditApproveVisible}
          setIsModalVisible={setIsEditApproveVisible}
          approveHandler={({ data = [], comment = "" }) => {
            const validIds = [...new Set([...data])];
            approveRequestHandler(validIds, comment, true); // saveDecisionOnly = true
          }}
          ids={isEditApproveVisible?.previousAmounts}
          totalAmount={isEditApproveVisible?.previousAmounts?.[0]?.totalAmount}
        />
      )}
      {isSendBackForReworkVisible.isOpen && (
        <SendBackForReworkModal
          isModalVisible={isSendBackForReworkVisible}
          setIsModalVisible={setIsSendBackForReworkVisible}
          reworkHandler={({ data, comment = "" }) => {
            sendBackForReworkHandler(data, comment);
          }}
        />
      )}
    </div>
  );
};

export default PendingApproval;
